import { apiUrl } from "../utils/utils"

export function useDownload() {
  return (url: string) => Promise.resolve(window.open(apiUrl(url), "_blank"))
}
